import { IConfigurationRegistry } from "../../../../base/domain/configuration";
import { IConfiguration } from "../../../domain/configuration";
import { IPublicEditableFormatRepository } from "../../../domain/editableFormat";
import { EditableFormatRepositoryBase } from "./EditableFormatRepositoryBase";

export class PublicEditableFormatRepository extends EditableFormatRepositoryBase implements IPublicEditableFormatRepository {
  constructor(getToken: () => string, configurationRegistry: IConfigurationRegistry<IConfiguration>) {
    super(getToken, configurationRegistry, "public/tree");
  }
}
